import { Field, Form, Formik } from "formik";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { io } from "socket.io-client";
import BeatLoader from "react-spinners/BeatLoader";
import axios from 'axios';
import { useNavigate } from "react-router-dom";

export default function AggiornamentoDati() {


  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [event, setEvent]: any = useState([]);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [timeLeft, setTimeLeft]: any = useState();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const triggerUPDNotification = async () => {
/*     try {
      const response = await axios.get('/api/v1/notifications/updData', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });
    } catch (error) {
      console.error("Errore nell'invio della notifica di test:", error);
      if (error.response) {
        // La richiesta è stata fatta e il server ha risposto con un codice di stato
        // che non rientra nell'intervallo 2xx
        console.error('Dati della risposta:', error.response.data);
        console.error('Status:', error.response.status);
        console.error('Headers:', error.response.headers);
      } else if (error.request) {
        // La richiesta è stata fatta ma non è stata ricevuta alcuna risposta
        console.error('Richiesta:', error.request);
      } else {
        // Qualcosa è andato storto nella configurazione della richiesta
        console.error('Errore:', error.message);
      }
    } */
  };



  useEffect(() => {

    const socket = io(`/`, {
      path: '/socket',
      query: {
        token: localStorage.getItem('token')
      }
    });

    socket.on('events', (payload) => {
      const { type, event_id, data } = payload;


      if (type === "beep" && event_id == event.id) {
        const { eta } = data;


        const now = moment();

        setTimeLeft(moment(now).diff(moment(), 'minutes', true));
      }
    });

  }, [event]);

  useEffect(() => {
    setLoading(true);
    (async () => {
      const request = await fetch(`/api/v1/events`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (request.status === 401 || request.status === 403 || request.status === 500) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        navigate('/');
        return;
      }

      const response = await request.json();
      setEvent(response.data[0]);
    })();
    setLoading(false);
  }, []);




  const handleFormSubmission = async (selectedModels, formikBag) => {
    try {
      setLoading(true);
      let list: any = [];


      const request = await fetch(`/api/v1/updates`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({
          actions: Object.keys(selectedModels).filter(x => selectedModels[x] === true),
        })
      });
      const response = await request.json();
      if (!request.ok) {
        throw new Error(response.errorMessage);
      }
      await formikBag.resetForm();
      toast.success("L'aggiornamento è stato pianificato",
        {
          position: "top-right",
          className: "m-5"
        }
      );
    } catch (e) {
      console.error(e);
      toast.error(e.message, {
        position: "top-right",
        className: "m-5"
      });
    } finally {
      setLoading(false);
    }
  }
  const formRef = useRef();
  return (
    <Formik
      innerRef={formRef}
      initialValues={{
        dashboard: false,
        orders: false,
        customers: false,
      }}
      validateOnChange={false}
      onSubmit={handleFormSubmission}
    >
      {({ isSubmitting }) => (


        <Form>
          {loading ? (
            <div className="flex justify-center items-center h-screen">
              <BeatLoader color="#2563eb" />
            </div>
          ) : (
            <div>
              {/* -------------- */}
              <div className="max-w-4xl mx-auto pt-[10rem]  px-5 md:py-8 sm:px-12 columns-3xl lg:columns-auto flex flex-col md:flex-row md:justify-center justify-start items-center h-[100vh] gap-12">
                <div className="">
                  <div className="sm:max-w-4xl mx-auto flex flex-col md:flex-row items-center justify-between relative mt-[100px] md:mt-50 mb-cu-m">
                    <div className="w-full text-center mb-4 md:mb-0 ">
                      <h2 className="text-4xl text-blue-500 font-bold">Aggiornamento Dati</h2>
                    </div>
                  </div>
                  {!event && <h3 className="text-2xl sm:text-xl sm:max-w-64 mb-6">Nessun record trovato per l'ultimo aggiornamento</h3>}
                  {event?.status === "pending" && <h3 className="text-2xl sm:text-xl sm:max-w-64 mb-6">Nessun record trovato per l'ultimo aggiornamento</h3>}
                  {["completed", "failed", "discarded"].includes(event?.status) && <h3 className="text-2xl sm:text-xl sm:max-w-64 mb-6">I dati attuali sono aggiornati al {moment(event?.note?.startedOn).format('DD/MM/YYYY')} alle ore {moment(event?.note?.startedOn).format('HH:mm')}</h3>}
                  <h4 className="text-xl sm:text-md sm:max-w-md mb-16">In caso di necessità di un aggiornamento ulteriore indicare di seguito quali categorie di dati è necessario aggiornare.</h4>


                  <div className="grid grid-cols-2 grid-rows-2 gap-4">
                    <div className="text-slate-500 p-4">
                      <div>
                        <Field id="modelCustomersCheck" className="w-4 h-4" type="checkbox" name="dashboard" />
                        <label className="text-xl ml-2" htmlFor="modelCustomersCheck">Dashboard</label>
                      </div>
                    </div>
                    <div className="text-slate-500 p-4">
                      <div>
                        <Field id="modelCustomerAddressesCheck" className="w-4 h-4" type="checkbox" name="orders" />
                        <label className="text-xl ml-2" htmlFor="modelCustomerAddressesCheck">Ordini</label>
                      </div>
                    </div>
                    <div className="text-slate-500 p-4">
                      <div>
                        <Field id="modelCustomerOrdersCheck" className="w-4 h-4" type="checkbox" name="orders" />
                        <label className="text-xl ml-2" htmlFor="modelCustomerOrdersCheck">BackOrder</label>
                      </div>
                    </div>
                    <div className="text-slate-500 p-4">
                      <div>
                        <Field id="modelListOrderCheck" className="w-4 h-4" type="checkbox" name="customers" />
                        <label className="text-xl ml-2" htmlFor="modelListOrderCheck">Clienti</label>
                      </div>
                    </div>
                  </div>





                </div>

                <div className="text-center">

                  <h3 className="text-blue-500 text-5xl">{!timeLeft ? '15 minuti' : (timeLeft <= 1 ? '<1m' : `${parseFloat(timeLeft).toPrecision(1)}m`)}</h3>


                  <h4 className="text-base mb-5 sm:mb-12">Tempo stimato per l’aggiornamento</h4>
                  <button type="submit" disabled={isSubmitting} className="py-3 px-4 inline-flex items-center gap-x-2 text-sm font-semibold  border-transparent bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50 disabled:pointer-events-none dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600" onClick={triggerUPDNotification}>Richiedi aggiornamento</button>
                </div>




              </div>
            </div>
          )}
        </Form>
      )}
    </Formik>
  );
}